import { memo, useCallback, useEffect, useState } from "react";
import destinationIcon from "../assets/images/destinationimg.svg";
import { useFieldArray } from "react-hook-form";
import { Cargo, enquiryStore } from "../enquiry/enquiry-data";
import { lclWeightForPort, maxDimensions, packageTypeList, weightPerPackage } from "../StaticData";
import { Quantity } from "../tailwind-components/Quantity";
import { TextWithSelect } from "../mui-components/TextWithSelect";
import { AgMuiSelect2 } from "../mui-components/Controlled";
import LabeledTextField from "../mui-components/LabeledTextField";
import { Add} from "@mui/icons-material";
import deleteicon from "../assets/images/deletei.svg";
import Utils from "../util/Utils";
import { FlexibleCenteredDiv } from "./AgFlexibleCenteredDiv";
import { TableHeading } from "./AgTableHeading";
import { HeadingWithSelect } from "./AgHeadingWithSelect";
import { useSnapshot } from "valtio";
import { AgmodalStore, filtersState, loginStore } from "../state/CommonState";
import { taskStore } from "../mytasks/task-store";
import { useGlobalState } from "../GlobalState";
import { TextField } from "@mui/material";
import { useMobile } from "../hooks/usemobile";
import { AgMobileUnitsBox } from "./AgMobileUnitsBox";

 const validateGreaterThanZero = (value,mode,Scope,volumeInDimensions,carting) => {
    console.log(" the volume in dimensions ",volumeInDimensions)
       let validation = parseFloat(value) > 0 || 'Required';
       
       if(value.length===0){
          validation='Required'
       }
       if(validation==='Required'){
        enquiryStore.isForEnquiry = false;
        return validation;
       }
    //    if(isNavexel && currentMenu!=="Spot Booking WIP" && !loginStore.isClient() && mode?.toLowerCase()==="lcl") return;
       if((mode?.toLowerCase()==="lcl" &&( Scope==="Port-to-Port" || (Scope?.includes("Door") && !volumeInDimensions)))||(mode==="air" && (carting!==undefined || carting===true) )) return;
       return validation
    };

export function MultiCargoDetails({form,viewonly,ind,changeToDimension}){
    const {currentMenu} = useGlobalState()
    const isNavexel = process.env.REACT_APP_ENTERPRISE_NAME_SMALLCASE === "navexel"
    const { control, watch, getValues, trigger, setValue,register,formState: { errors } } = form;
    const { fields: cargoDetails, append: appendCargo, remove: removeCargo } = useFieldArray({
        control: control,
        name: `multidest.${ind}.cargoDetails`
    })
    const [dis,setDis] = useState(false)
    const [showModal,setShowModal] = useState(false)
    const [cargokey,setCargokey] = useState(Date.now() + '-' + Math.floor(Math.random() * 1000))
    useSnapshot(AgmodalStore)
    useSnapshot(loginStore)
    const Mode = watch("mode")
    const mode = Mode.toLowerCase();
    const Scope = watch("scope")
    const [total,setTotal] = useState({ totNumPackages : 0,
        totTotalWeight : 0,
        totTotalVolume : 0,
        totChargeableWeight : 0})
    const [isDimension,setIsDimension] = useState(undefined)
    const isFBA = watch("isFba");
    const palletizationandlabelling = watch("palletizationandlabelling");
    let cargodetailsFromForm = watch(`multidest.${ind}.cargoDetails`);
    const totalWeight = getValues(`multidest.0.cargoDetails.0.totalWeight.unit`);
    const totalVolume = getValues(`multidest.0.cargoDetails.0.totalVolume.unit`);
    const weight = getValues(`multidest.0.cargoDetails.0.weight.unit`);
    const multidest = getValues('multidest')
    const dimensionsUnit = watch("cargoDimensionUnit");
    const cartingorder = watch("cartingorder");
    const volumeInDimensions = watch("volumeInDimensions")
    const stuffingType = watch("stuffingType")
    const destuffingType = watch("destuffingType");
    const isMobile = useMobile();
    let containerDetails = watch("containerDetails")
     const obj = {
        "stuffingType":stuffingType,
        "destuffingType":destuffingType,
        "shipmentType":mode,
        "shipmentScope":Scope
    }
    console.log(" the multidest on volumedimension chganged ",multidest);
    const calculateWeightAndVolume = ()=>{
        if(JSON.stringify({ totNumPackages : 0,
            totTotalWeight : 0,
            totTotalVolume : 0,
            totChargeableWeight : 0})!=JSON.stringify(total)){
                setTotal({ totNumPackages : 0,
                    totTotalWeight : 0,
                    totTotalVolume : 0,
                    totChargeableWeight : 0})
            }
        if(getValues(`multidest.${ind}.cargoDetails`)!=undefined){
            let totals = Utils.calcCargoDetails(getValues(`multidest.${ind}.cargoDetails`),isDimension,dimensionsUnit,mode,multidest[0]['cargoDetails'][0]);
            setTotal({...totals});
            setValue(`multidest.${ind}.cargoDetails.grandTotals`,totals)
        }
    }
    const generateId = useCallback((id,i)=> {
        if(id==undefined || id==0){
            let a = i + Date.now() + '-' + Math.floor(Math.random() * 1000)
            cargodetailsFromForm[i].id = a
            return a
        }else{
            return id
        }
    },[cargodetailsFromForm])
    useEffect(()=>{
        if(!dis && taskStore.current.actionName == 'Booking Amendment' && currentMenu == 'Bookingsv3'){
            setDis(true)
        }
        if(viewonly){
            if(!dis){
                setDis(true)
            }
        }else{
            if(dis){
                setDis(false)
            }
        }
    },[AgmodalStore])
   useEffect(()=>{
    calculateWeightAndVolume();
   },[JSON.stringify(cargodetailsFromForm)])
    useEffect(()=>{
        setValue(`multidest.0.cargoDetails.0.totalWeight.unit`,weight)
        for(let i = 1; i < cargoDetails.length;i++){
                setValue(`multidest.${ind}.cargoDetails.${i}.weight.unit`,weight)
        }
        calculateWeightAndVolume();
    },[weight])

    useEffect(()=>{
        for(let i = 1; i < cargoDetails.length;i++){
            setValue(`multidest.${ind}.cargoDetails.${i}.totalWeight.unit`,totalWeight)
        }
        calculateWeightAndVolume();
    },[totalWeight])

    useEffect(()=>{
        for(let i = 1; i < cargoDetails.length;i++){
            setValue(`multidest.${ind}.cargoDetails.${i}.totalVolume.unit`,totalVolume)
        }
        calculateWeightAndVolume();
    },[totalVolume])

    useEffect(()=>{
        calculateWeightAndVolume();
    },[dimensionsUnit]);

   
    useEffect(()=>{
        calculateWeightAndVolume();
    },[isDimension])

    console.log(" the chnage to dimension is ",changeToDimension)

    

   

    useEffect(()=>{
        if((cartingorder==undefined || cartingorder==false)||(taskStore.current.actionName == "Booking Amendment" && taskStore.triggerActionVisible)){
        //    ( mode === "fcl" && ((cartingorder==undefined || cartingorder==false) || (Utils.labelForOutGauge1(obj,containerDetails) && Scope.includes("Door") )))
            if ((mode === "lcl" && Scope.includes("Door") || (mode === "air" && (cartingorder==undefined || cartingorder==false)) || (mode==='fcl' && (cartingorder==undefined || cartingorder==false)) ) && changeToDimension ){
                    setIsDimension(true)
            }else{
                if(isDimension || isDimension==undefined){
                    setIsDimension(false)
                }
            }
        }else{
            if((mode === "lcl" && Scope.includes("Door") && changeToDimension)){
                 setIsDimension(true);
            }else if((isDimension || isDimension==undefined)){
                setIsDimension(false)
            }
        }
    },[mode,Scope,changeToDimension,isDimension,containerDetails])

    return <div className="w-full flex flex-col gap-2 items-end" key={generateId(cargodetailsFromForm[0]['id'],0)}>
        {
            isDimension!=undefined && cargodetailsFromForm.length>0 && cargodetailsFromForm[0]['id']!=undefined && ( isMobile ? <div className="w-full flex flex-col gap-3">
            {
                multidest.length > 1 && (
                    <div className="flex flex-row w-full min-h-[38px] py-1.5 items-center border-[0.5px] border-solid border-[#DBDEFF] px-[12px] rounded-[6px] bg-[#DBDEFF] overflow-hidden">
                        <div className="flex flex-row items-center w-full min-w-0 gap-1.5">
                            <img src={destinationIcon} className="w-4 h-4 flex-shrink-0" alt="destination" />
                            <span className="font-bold text-xs text-[#2C358A] whitespace-nowrap flex-shrink-0">
                                Destination {ind + 1} :
                            </span>
                            <span className="text-xs text-[#333333] font-medium truncate flex-1 min-w-0" title={getValues(`multidest.${ind}.destination`)}>
                                {getValues(`multidest.${ind}.destination`) || ""}
                            </span>
                        </div>
                    </div>
                )
            }
            <AgMobileUnitsBox
                control={control}
                dis={dis}
                isDimension={isDimension}
                mode={mode}
                calculateWeightAndVolume={calculateWeightAndVolume}
                trigger={trigger}
            />
            {cargodetailsFromForm.map((cargodetail,i)=><div key={generateId(cargodetail.id,i)} className="w-full flex flex-col gap-3 bg-white rounded-[6px] border border-[#E8E8E8]">
              {i > 0 && <div className="w-full border-t border-dotted border-[#D4D4D4] border-b-0 my-2" />}
              <div className="w-full flex flex-row justify-between items-center">
                <span className="text-[#2C358A] font-bold text-sm">Row {i + 1}</span>
                { !viewonly && cargodetailsFromForm.length > 1 && 
                  <div onClick={()=>{
                    filtersState.initialize();
                    removeCargo(i);
                  }} className="w-7 h-7 flex items-center justify-center bg-[#FFEAEA] border border-[#FCA5A5] rounded-[4px] cursor-pointer hover:bg-[#FEE2E2] transition-colors">
                    <img src={deleteicon} alt="delete" className="w-4 h-4"/>
                  </div>
                }
              </div>
              <div className="w-full flex flex-row gap-2">
                <MobileViewSingleComponentLayout title="Package Type*" width="70%">
                    <PackageTypeComponent form={form} viewonly={viewonly} i={i} ind={ind} isFBA={isFBA}/>
                </MobileViewSingleComponentLayout>
                <MobileViewSingleComponentLayout title="Quantity*" width="30%">
                    <QuantityComponent form={form} viewonly={viewonly} i={i} ind={ind} mode={mode} Scope={Scope} volumeInDimensions={volumeInDimensions}/>
                </MobileViewSingleComponentLayout>
              </div>
              <div className={`w-full flex ${isDimension?"flex-col":"flex-row"} gap-2`}>
              <MobileViewSingleComponentLayout title={isDimension ? (mode === "lcl" ? "Weight per package *" : "Weight Per Piece *") : "Total Weight *"} width={isDimension?"100%":"50%"}>
                <WeightFieldComponent {...{form,ind,i,mode,Scope,viewonly,isDimension,dimensionsUnit,weight,totalWeight,volumeInDimensions,cargodetail}}  />
              </MobileViewSingleComponentLayout>
              <MobileViewSingleComponentLayout title={isDimension ? "Dimensions *" : "Total Volume *"} width={isDimension?"100%":"50%"}>
                    <VolumeFieldComponent {...{form,ind,i,mode,Scope,viewonly,isDimension,dimensionsUnit,totalVolume,volumeInDimensions}}  />
              </MobileViewSingleComponentLayout>
              </div>
            </div>)}
            { !viewonly &&
                <button onClick={()=>{
                    let newCargo = new Cargo();
                    newCargo.totalVolume.unit = totalVolume;
                    newCargo.totalWeight.unit = totalWeight;
                    newCargo.weight.unit = weight;
                    filtersState.initialize();
                    appendCargo({ ...newCargo });
                }} type="button" className="w-full h-[40px] flex flex-row gap-[6px] justify-center items-center font-bold bg-[#F5F8FF] border-[1px] border-dashed border-[#5A78FA] rounded-[6px] text-[#2C358A] cursor-pointer hover:bg-[#EBF2FF] transition-colors mt-1">
                    <Add sx={{fontSize:"20px",color:"#2C358A"}}/>
                    <span className="text-[#2C358A] font-semibold text-sm">Add Row</span>
                </button>
            }
            <div className="w-full flex flex-col gap-2.5 items-start mt-2">
                <ShowTotal mode={mode} register={register} errors={errors} ind={ind} total={total} multidest={multidest} />
            </div>
            </div> : <>
    <div className="flex flex-col w-full" key={generateId(cargodetailsFromForm[0]['id'],0)}>
    {
        multidest.length > 1 && (
            <div className="flex flex-row w-full h-[35px] items-center border-[0.5px] border-solid border-[#DBDEFF] border-b-0 px-[12px] bg-[#DBDEFF] overflow-hidden">
                <div className="flex flex-row items-center flex-1 min-w-0 gap-1.5">
                    <img src={destinationIcon} className="w-4 h-4 flex-shrink-0" alt="destination" />
                    <span className="font-bold text-xs text-[#2C358A] whitespace-nowrap flex-shrink-0">
                        Destination {ind + 1} :
                    </span>
                    <span className="text-xs text-[#333333] font-medium truncate flex-1 min-w-0" title={getValues(`multidest.${ind}.destination`)}>
                        {getValues(`multidest.${ind}.destination`) || ""}
                    </span>
                </div>
            </div>
        )
    }
    
    <div className={`flex flex-row w-full h-[35px] items-center border-[0.5px] border-solid border-[#D4D4D4] border-b-0 px-[12px]`}>
    
       <FlexibleCenteredDiv>
           <TableHeading title="Package Type*" />   
       </FlexibleCenteredDiv>
       <FlexibleCenteredDiv>  <TableHeading title="Quantity *" /></FlexibleCenteredDiv>
     <FlexibleCenteredDiv> 
         <HeadingWithSelect key={isDimension} disabled={dis} onDropdownChange={()=>{
            filtersState.initialize();
             //calculateWeightAndVolume();
         }} heading={(isDimension)? mode === "lcl" ? "Weight per package *" : "Weight Per Piece *" : "Total Weight *"} options={["Kgs", "Tons", "Lbs"]} name={`multidest.0.cargoDetails.0.weight.unit`} control={control} />
         {/* <TableHeading title={ (isDimension)? mode === "lcl" ? "Weight per package *" : "Weight Per Piece *" : "Total Weight *"} /> */}
         </FlexibleCenteredDiv>
     <div className={`flex flex-col flex-1`}>    

    {isDimension?<div className="flex flex-row items-center justify-center w-[300px] gap-1 flex-1 ">
         <TableHeading title="Dimensions* x" />
         <AgMuiSelect2 disabled={dis} onChangeHandler={async ()=>{
             //calculateWeightAndVolume();
             filtersState.initialize();
             await trigger([`multidest`]);
         }}  padding={0} control={control} name={"cargoDimensionUnit" } size="small"  variant="standard" disableUnderline={true} values={ ['Cms', 'MM', 'Inches', "Meters", 'Feet']} options={['Cms', 'MM', 'Inches', "Meters", 'Feet'] } fontColor="#555555" iconColor="#555555"  style={{ fontSize: "12px", alignItems:"center", height:"25px",
             // minWidth:"68px",
             fontSize:"13px",
             fontWeight:"bold",
             color: "#555555",
             borderLeft :0,
             padding:0,
             // paddingRight: "8px",
             backgroundColor:"white", }} />
     </div>: <FlexibleCenteredDiv>
         <HeadingWithSelect disabled={dis} onDropdownChange={()=>{
            filtersState.initialize();
             calculateWeightAndVolume();
         }} control={control} name={`multidest.0.cargoDetails.0.totalVolume.unit`} options={['CBM', 'cu ft']} heading={"Total Volume*"}/>
         </FlexibleCenteredDiv>}
     </div>
     {cargodetailsFromForm.length > 1 && <div className="w-[35px] h-full"></div>}
     </div>
    {cargodetailsFromForm.map((cargodetail,i)=> <div className={`flex flex-row w-full py-[8px] items-center px-[12px] ${i%2===0 ? "bg-[#F3F3F3]" :  "bg-white border-[0.5px] border-solid border-[#D4D4D4]" }`}>
       <FlexibleCenteredDiv >
          <PackageTypeComponent key={generateId(cargodetail.id,i)} i={i} form={form} viewonly={viewonly} ind={ind} isFBA={isFBA}  />
       </FlexibleCenteredDiv>
       <FlexibleCenteredDiv >
          <QuantityComponent key={generateId(cargodetail.id,i)} i={i} form={form} viewonly={viewonly} ind={ind} mode={mode} Scope={Scope} volumeInDimensions={volumeInDimensions} />
       </FlexibleCenteredDiv>
       <FlexibleCenteredDiv>
          <WeightFieldComponent key={generateId(cargodetail.id,i)+isDimension} weight={weight} totalWeight={totalWeight}  i={i} form={form} viewonly={viewonly} ind={ind} mode={mode} Scope={Scope} isDimension={isDimension} cargodetail={cargodetail} volumeInDimensions={volumeInDimensions} />
       </FlexibleCenteredDiv>
       <FlexibleCenteredDiv className={isDimension?`flex-none w-[300px]`:""}>
          <VolumeFieldComponent form={form} ind={ind} i={i} mode={mode} Scope={Scope} viewonly={viewonly} isDimension={isDimension} dimensionsUnit={dimensionsUnit} totalVolume={totalVolume} volumeInDimensions={volumeInDimensions}/>
       </FlexibleCenteredDiv>
        { !viewonly && cargoDetails.length > 1 && 
        <div onClick={()=>{
        //  const currentType = getValues(`multidest.${ind}.cargoDetails.${i}.packageType`);
        //  if(currentType==="Loose Cartons"){
        //      setValue("showPalletLabel",false)
        //  }
        filtersState.initialize()
         removeCargo(i);
        }} className="w-[35px] h-full flex items-center justify-center cursor-pointer">
<img src={deleteicon}/>
        </div>
                 // : <CenteredBox sx={{width:"34px"}}/>
             }
     </div>)}

    </div>
    <div className="flex flex-row justify-between items-start w-full">
    {/* <div className="flex flex-row gap-2.5 mr-auto pt-[2.5px] flex-1"><p className="text-blue-dark font-bold font-barlow">{mode.toLowerCase()==="lcl"&& multidest?.length===1 ? "Grand " : ""}Total Quantity :</p><p className="text-yellow font-bold font-barlow">{isNaN(total.totNumPackages)?0:total.totNumPackages}</p></div> */}
      <ShowTotal mode={mode} register={register} errors={errors} ind={ind} total={total} multidest={multidest} />
      {!loginStore.isClient() && isFBA && palletizationandlabelling && multidest!=undefined && multidest.length>0 && multidest[ind]?.binstackResponse!=undefined && <div className="flex flex-row gap-2.5"><p className="text-blue-dark font-bold font-barlow">Number of Pallets:</p><p className="text-yellow font-bold font-barlow">{multidest[ind]?.binstackResponse?.totalPallet}<span className="icon" style={{cursor:"pointer"}} onClick={()=>{
        setShowModal(true)
      }}>
                                                    <i className="fas fa-circle-info"></i>
                                                </span></p></div>}
      {/* } */}
      {/* { mode==="air" && <div className="flex flex-row gap-2.5"><p className="text-blue-dark font-bold font-barlow">Chargeable Weight:</p><p className="text-yellow font-bold font-barlow">{isNaN(total.totChargeableWeight)?0:total.totChargeableWeight} Kgs</p></div>} */}
      { !viewonly &&
    <button onClick={()=>{
         let newCargo = new Cargo();
         newCargo.totalVolume.unit = totalVolume;
             newCargo.totalWeight.unit = totalWeight;
             newCargo.weight.unit = weight;
             filtersState.initialize();
         appendCargo({ ...newCargo });
     }} type="button" className="bg-[#F7F7F7] border-[1px] border-solid border-[#E8E8E8] h-[35px] w-[110px] rounded-[6px] ">
         <div className="flex h-full w-full flex-row gap-[5px] justify-center items-center font-bold">
             <Add sx={{fontSize:"22px",color:process.env.REACT_APP_ENTERPRISE_COLOUR}}/>
             <p className="text-grey">Add Row</p>
         </div>
     </button>}
    </div>
    {showModal && <div className={`modal ${showModal && "is-active"}`} onClick={() => { 
        setShowModal(false)
        }}>
            <div className="modal-background" ></div>
            <div className="modal-card" onClick={(e) => { e.stopPropagation() }} style={{ borderRadius: '10px' }} >
                <section className="modal-card-body" >

                <h2 className="text-blue-dark font-bold font-barlow">Pallet Details</h2>
                <div className="table-container">
                <table className="table is-bordered is-striped is-fullwidth is-hoverable ">
                    <thead>
                        <tr>
                            <th>Weight</th>
                            <th>Total Height</th>
                            <th>Total Length</th>
                            <th>Total Width</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            multidest[ind]?.binstackResponse?.palletDetails.map(e=>{
                                return <tr>
                                    <td>{e.weight}</td>
                                    <td>{e.totalHeight}</td>
                                    <td>{e.totalLength}</td>
                                    <td>{e.totalWidth}</td>
                                </tr>
                            })
                        }
                    </tbody>
                    </table></div>
                    <div style={{textAlign:"right"}}>
                    <button class="button is-warning" onClick={() => setShowModal(false)} >close</button>
                    </div>              
                </section>
            </div>
        </div>}
    </>)
        }
 </div>
}

const MobileViewSingleComponentLayout = ({children,title,width="50%"})=>{
    return <div className={`w-[${width}] flex flex-col gap-1 text-[#2C358A] text-sm`} style={{ width: width }}>
             <p className="">{title}</p>
             {children}
    </div>
}

const MobileViewCargoDetails=({form})=>{
    return <div className="w-full flex flex-col gap-2 items-end">
              <div className="w-full flex flex-row gap-2">
                <div className="w-[60%] flex flex-col gap-2">
                    <p>Package Type*</p>
                    <PackageTypeComponent/>
                </div>
              </div>
    </div>
}

const PackageTypeComponent = memo(({form,viewonly,i,ind,isFBA})=>{ 
    const isMobile = useMobile();
    const {setValue,control,getValues} = form;
    return  <AgMuiSelect2 getValues={getValues} disabled={viewonly} width={isMobile?"100%":"170px"} style={{height:"25px"}} onChangeHandler={(value)=>{
        filtersState.initialize();
         if( isFBA && value==="Loose Cartons"){
              setValue("showPalletLabel",true)
         }else{
             setValue("showPalletLabel",false)
         }
       }} onBlur={()=>{
                 }} rules={{ validate:(value)=>{
                    if( !value || value.length===0){
                        enquiryStore.isForEnquiry = false;
                        return "Required";
                    }else{
                        enquiryStore.isForEnquiry = true;
                    }
                 } }}  size="small" fontSize="12px" options={isFBA?["Pallet","Loose Cartons"]:packageTypeList} control={control} name={`multidest.${ind}.cargoDetails.${i}.packageType`} />
})

const QuantityComponent = memo(({form,ind,i,mode,viewonly,Scope,volumeInDimensions})=>{
    const {setValue,getValues,control} = form;
    const isMobile = useMobile();
    return  <Quantity width={isMobile ? "100%" : "90px"} onChange={()=>{
            filtersState.initialize();
         }} getValues={getValues} disabled={viewonly} callback={(e)=>{setValue(`multidest.${ind}.cargoDetails.${i}.quantity`,e)}} control={control} name={`multidest.${ind}.cargoDetails.${i}.quantity`} rules={{ required: "Required", validate: (value)=>{
            const isValue = validateGreaterThanZero(value,mode,Scope,volumeInDimensions,getValues('cartingorder'));
            if(!isValue) return
            if (typeof isValue === "string") {
                enquiryStore.isForEnquiry = false;
                return isValue
            }else{
                enquiryStore.isForEnquiry = true;
            } 
         } }} />
})

const WeightFieldComponent = memo(({form,ind,i,mode,Scope,isDimension,weight,totalWeight,cargodetail,viewonly,volumeInDimensions})=>{
    const {setValue,getValues,control} = form
    const isMobile = useMobile();
    const fieldWidth = isMobile ? "100%" : "170px"
    return isDimension ?  <TextWithSelect onChange={()=>{
             filtersState.initialize();
         }} getValues={getValues} disabled={viewonly} textFieldWidth={fieldWidth}  name={`multidest.${ind}.cargoDetails.${i}.weight.value` } control={control} unit={mode === "air" ? weight : totalWeight}  rules={{
                     required: "Required", validate: (value) => {
                         let isValue = validateGreaterThanZero(value,mode,Scope,volumeInDimensions,getValues('cartingorder'));
                         console.log(" the weight is gfjjjhbf jhjbh  ",isValue)
                         if(!isValue) return
                         if (typeof isValue === "string" || (isDimension && mode.toLowerCase()==="lcl")) {
                             return isValue
                         } 
                         else if(mode!=="fcl") {
                             let unit =  getValues(`multidest.0.cargoDetails.0.weight.unit`);
                           
                             let maxValue = weightPerPackage[mode][unit.toLowerCase()];
                             if (parseFloat(value) > maxValue) {
                                 // configStore.setModalMessage(`Length for ${packageType} package should be less than ${shipmentType === 'air' ? 400 : 1190}.`)
                                 return `value can't be greater than ${maxValue + " " + unit} `;
                             }
                         }
                     }
                 }} /> : <TextWithSelect textFieldWidth={fieldWidth} onChange={()=>{
                    filtersState.initialize();
                }} getValues={getValues} disabled={viewonly} unit={totalWeight}   options={["Kgs", "Tons", "Lbs"]} control={control} name={`multidest.${ind}.cargoDetails.${i}.totalWeight.value`} selectName={`multidest.0.cargoDetails.0.totalWeight.unit`} rules={{ required: "Required", validate: (value) => {
                     let isValue = validateGreaterThanZero(value,mode,Scope,volumeInDimensions,getValues('cartingorder'));
                    
                     if(!isValue) return
                     const totalWeight =  getValues( `multidest.0.cargoDetails.0.totalWeight.unit`);
                     if (typeof isValue === "string") {
                         return isValue
                     } 
                     else if(mode!=="fcl") {
                        let l = Utils.toNum(cargodetail.quantity)
                        if(l>0){
                         let maxValue = l*weightPerPackage[mode][totalWeight.toLowerCase()]
                         if (parseFloat(value) > maxValue) {
                             // configStore.setModalMessage(`Length for ${packageType} package should be less than ${shipmentType === 'air' ? 400 : 1190}.`)
                             return `value can't be greater than ${maxValue + " " + totalWeight} `;
                         }
                        }
                     }
                 } }} /> 
})

{/* <FlexibleCenteredDiv className={`flex-none w-[300px]`}> */}
const VolumeFieldComponent = memo(({form,ind,i,mode,Scope,viewonly,isDimension,dimensionsUnit,totalVolume,volumeInDimensions})=>{
    const {setValue,getValues,control} = form
    const isMobile = useMobile()
     const LabelStyle = "flex items-center justify-center border-l-[0.5px] border-l-solid border-l-[#D4D4D4] font-bold text-sm min-w-[24px] h-full"
    const DimensionLabelStyle = {height:"25px",width:isMobile?"100%":"80px",padding:0,fontSize:"13px"}
    return  isDimension ? <div  className="flex flex-row w-full gap-1">
             <LabeledTextField onChange={()=>{
             filtersState.initialize();
         }} disabled={viewonly}  textfieldStyles={DimensionLabelStyle} rules={{
                     required: "Required", validate: (value) => {
                         let isValue = validateGreaterThanZero(value,mode,Scope,volumeInDimensions,getValues('cartingorder'));
                         if(!isValue) return
                         if (typeof isValue === "string") {
                             return isValue
                         }
                          else if(mode!=="fcl"){
                            
                             let maxValue = maxDimensions[mode][dimensionsUnit.toLowerCase()].length
                             
                             if (value > maxValue) {
                                 // configStore.setModalMessage(`Length for ${packageType} package should be less than ${shipmentType === 'air' ? 400 : 1190}.`)
                                 return `value can't be greater than ${maxValue+" "+dimensionsUnit} `;
                             }
                         }
                     }
                 }} control={control} name={`multidest.${ind}.cargoDetails.${i}.dimensions.length`} endAdornment={<div className={LabelStyle}>L</div>}  />
             <p>x</p>
             <LabeledTextField onChange={()=>{
             filtersState.initialize();
         }} disabled={viewonly} textfieldStyles={DimensionLabelStyle} rules={{
                     required: "Required", validate: (value) => {
                         let isValue = validateGreaterThanZero(value,mode,Scope,volumeInDimensions,getValues('cartingorder'));
                         if(!isValue) return
                         if (typeof isValue === "string") {
                             return isValue
                         } 
                         
                         else if(mode!=="fcl"){
                            
                             let maxValue = maxDimensions[mode][dimensionsUnit.toLowerCase()].width
                             
                             if (value > maxValue) {
                                 // configStore.setModalMessage(`Length for ${packageType} package should be less than ${shipmentType === 'air' ? 400 : 1190}.`)
                                 return `value can't be greater than ${maxValue+" "+dimensionsUnit} `;
                             }
                         }
                     }
                 }} control={control} name={`multidest.${ind}.cargoDetails.${i}.dimensions.width`} endAdornment={<div className={LabelStyle}>W</div>}  />
             <p>x</p>
             <LabeledTextField onChange={()=>{
             filtersState.initialize();
         }} disabled={viewonly} textfieldStyles={DimensionLabelStyle} rules={{
                     required: "Required", validate: (value) => {
                         let isValue = validateGreaterThanZero(value,mode,Scope,volumeInDimensions,getValues('cartingorder'));
                         if(!isValue) return
                         if (typeof isValue === "string") {
                             return isValue
                         } 
                         else if(mode!=="fcl"){
                            
                             let maxValue = maxDimensions[mode][dimensionsUnit.toLowerCase()].height
                             
                             if (value > maxValue) {
                                 // configStore.setModalMessage(`Length for ${packageType} package should be less than ${shipmentType === 'air' ? 400 : 1190}.`)
                                 return `value can't be greater than ${maxValue+" "+dimensionsUnit} `;
                             }
                         }
                     }   
                 }} control={control} name={`multidest.${ind}.cargoDetails.${i}.dimensions.height`} endAdornment={<div className={LabelStyle}>H</div>}  />
         </div> : <TextWithSelect textFieldWidth={isMobile ? "100%" : "170px"} onChange={()=>{
             filtersState.initialize();
         }} getValues={getValues} disabled={viewonly}  unit={totalVolume}  options={['CBM', 'cu ft']}
         rules={{ required: "Required", validate: (value) => {
             let isValue = validateGreaterThanZero(value,mode,Scope,volumeInDimensions,getValues('cartingorder'));
             
             if(!isValue) return
             const totalVolume = getValues(`multidest.0.cargoDetails.0.totalVolume.unit`)
             if (typeof isValue === "string") {
                 return isValue
             } 
             else if(mode!=="fcl"){
                
                 let maxValue = lclWeightForPort["totalvolume"][totalVolume.toLowerCase()]
                 
                 if (value > maxValue) {
                     // configStore.setModalMessage(`Length for ${packageType} package should be less than ${shipmentType === 'air' ? 400 : 1190}.`)
                     return `value can't be greater than ${maxValue+" "+totalVolume} `;
                 }
             }
         } }}
         selectName={`multidest.0.cargoDetails.0.totalVolume.unit`} control={control} name={`multidest.${ind}.cargoDetails.${i}.totalVolume.value`} />
})

const ShowTotal = ({mode,errors,ind,total,register,multidest})=>{
    
    return <>
         <div className="flex flex-col ">
     <div className="flex flex-row gap-2.5">
        <p className="text-blue-dark font-bold font-barlow pt-[2.5px]">{mode.toLowerCase()==="lcl"&& multidest?.length===1 ? "Grand" : ""} Total Quantity :</p>
        <TextField
          variant="standard"
          value={isNaN(total.totNumPackages)?0:total.totNumPackages}
          fullWidth={false}
          inputProps={{
             style:{
                color:"#F4B14A",
                fontWeight:"bold",
                fontFamily:"Barlow"
             }
          }}
          sx={{
    width: `${String(total.totNumPackages || 0).length + 1}ch`,       
    minWidth: "20px",
    "& .MuiInputBase-input": {
      color: "#F4B14A",
      fontWeight: "bold",
      fontFamily: "Barlow"
    }
  }}
          InputProps={{
            disableUnderline: true,
            readOnly: false,
             style:{
                color:"#F4B14A",
                fontWeight:"bold",
                fontFamily:"Barlow"
             }
          }}
        />
        {/* <p className="text-yellow font-bold font-barlow">{isNaN(total.totTotalWeight)?0:total.totTotalWeight} Kgs</p> */}
        </div>
     </div>
    <div className="flex flex-col ">
     <div className="flex flex-row gap-2.5">
        <p className="text-blue-dark font-bold font-barlow pt-[2.5px]">{mode.toLowerCase()==="lcl"&& multidest?.length===1 ? "Grand" : ""} Total Weight:</p>
        <TextField
          {...register(`multidest.${ind}.cargoDetails.grandTotals.grandTotalWeight`, { validate:()=>{
            let maxValue = lclWeightForPort.grandtotalweight["kgs"]
            let value = total.totTotalWeight
            console.log(" the macx total weight value is . . . . ",maxValue, " current value ",value)
             if(value > maxValue && mode.toLowerCase()==="lcl" && multidest?.length===1){
                return `value can't be greater than ${maxValue} Kgs.`
             }
          } })}
          variant="standard"
          value={isNaN(total.totTotalWeight)?0:total.totTotalWeight+ " " +"Kgs"}
          fullWidth={false}
          inputProps={{
             style:{
                color:"#F4B14A",
                fontWeight:"bold",
                fontFamily:"Barlow"
             }
          }}
          InputProps={{
            disableUnderline: true,
            readOnly: false,
             style:{
                color:"#F4B14A",
                fontWeight:"bold",
                fontFamily:"Barlow"
             }
          }}
          sx={{
             width: `${String(total.totTotalWeight || 0).length + 5 }ch`, 
             "& .MuiInputBase-input": {
               color: "#F4B14A",
               fontWeight: "bold",
               fontFamily: "Barlow"
             }
          }}
        />
        {/* <p className="text-yellow font-bold font-barlow">{isNaN(total.totTotalWeight)?0:total.totTotalWeight} Kgs</p> */}
        </div>
        { errors.multidest && errors.multidest[ind]?.cargoDetails?.grandTotals?.grandTotalWeight && <p className="text-[#d32f2f] text-sm">{errors.multidest[ind].cargoDetails?.grandTotals.grandTotalWeight.message}</p>}
     </div>
      { !(mode==="air") &&  
          <div className="flex flex-col">
          <div className="flex flex-row gap-2.5">
             <p className="text-blue-dark font-bold font-barlow pt-[2.5px]">{mode.toLowerCase()==="lcl" && multidest?.length===1 ? "Grand" : ""} Total Volume:</p>
             <TextField
               {...register(`multidest.${ind}.cargoDetails.grandTotals.grandTotalVolume`, { validate:()=>{
                let value = total.totTotalVolume
                let maxValue = lclWeightForPort.grandtotalvolume["cbm"]
                  if(value > maxValue && mode.toLowerCase()==="lcl"&& multidest?.length===1){
                     return `value can't be greater than ${maxValue} CBM.`
                  }
               } })}
               variant="standard"
               value={isNaN(total.totTotalVolume)?0:total.totTotalVolume+ " " +"CBM"}
               fullWidth={false}
               inputProps={{
                 style:{
                    color:"#F4B14A",
                    fontWeight:"bold",
                    fontFamily:"Barlow"
                 }
               }}
               InputProps={{
                 disableUnderline: true,
                 readOnly: false,
                  style:{
                     color:"#F4B14A",
                     fontWeight:"bold",
                     fontFamily:"Barlow"
                  }
               }}
                sx={{
             width: `${String(total.totTotalVolume || 0).length + 5 }ch`, 
             "& .MuiInputBase-input": {
               color: "#F4B14A",
               fontWeight: "bold",
               fontFamily: "Barlow"
             }
          }}
             />
             {/* <p className="text-yellow font-bold font-barlow">{isNaN(total.totTotalWeight)?0:total.totTotalWeight} Kgs</p> */}
             </div>
             {errors.multidest && errors.multidest[ind]?.cargoDetails?.grandTotals?.grandTotalVolume && <p className="text-[#d32f2f] text-sm">{errors.multidest[ind].cargoDetails.grandTotals.grandTotalVolume.message}</p>}
          </div>
      }
      { mode==="air" &&  
      <div className="flex flex-row gap-2.5"><p className="text-blue-dark font-bold font-barlow">Chargeable Weight:</p><p className="text-yellow font-bold font-barlow">{isNaN(total.totChargeableWeight)?0:total.totChargeableWeight} Kgs</p>
      </div>}
    </>
}